import bem from '../../../utils/bem';
import Tip from '../../Atoms/tip';
import Button from '../../Atoms/Button';
import Icon from '../../Atoms/Icon/Icon';

const LeadGenToolsPageHero = ({
  title,
  subTitle,
  description,
  onResetSearch,
  bemBlock,
  extra,
  mods,
}) => {
  return (
    <div className={bem('page-heading', mods, bemBlock, extra)}>
      <h1 className={bem('page-title', [], bemBlock, ['h', 'h2', 'text-blue'])}>
        {title}
      </h1>
      {subTitle && (
        <h2 className={bem('page-sub-heading', [], bemBlock, ['h', 'h4'])}>
          {subTitle}
        </h2>
      )}
      {description && (
        <div className="flex justify-between">
          <p className={bem('page-subtitle', [], bemBlock, [])}>
            {description}
          </p>

          <Button
            extra={[bem('reset-btn', [], bemBlock, [])]}
            mods={['secondary']}
            onClick={onResetSearch}
          >
            <Icon iconName="search-thick" width={24} height={24} />
            {Drupal.t('Restart Search')}
          </Button>

          <Button
            block={[bem('back-btn', [], bemBlock, [])]}
            extra={['btn-back text-blue']}
            onClick={onResetSearch}
          >
            {Drupal.t('Restart Search')}
          </Button>
          <Tip
            content={description}
            iconWidth={24}
            iconHeight={24}
            extra={[[bem('headline-tip', [], bemBlock, [])]]}
          />
        </div>
      )}
    </div>
  );
};

export default LeadGenToolsPageHero;
